module.exports = __webpack_public_path__ + "img/1f63a.f6d69d3.svg";